import React from 'react'
import PropTypes from 'prop-types'
import { OnChange } from 'react-final-form-listeners'
import { Form } from 'react-final-form'
import TextInput from '../../input/textInput'
import QuestionHeader from './questionHeader'
import TextBox from 'components/textbox/textbox'

export default function RenderTextInput({ elmIndex, elm, valIndex, valueChange, allowModify }) {
  if (!elm.Value) elm.Value = []
  if (!elm.Value[valIndex]) elm.Value[valIndex] = ['']

  const elmValueChange = (newVal) => { valueChange(elmIndex, valIndex, [newVal]) }
  const name = `elm-${elmIndex}-val-${valIndex}-0`
  const initialValues = {}
  initialValues[name] = elm.Value[valIndex][0] ?? ''
  return <div key={elmIndex}>
    <QuestionHeader helpTooltip={elm.ShowHelpTooltip ? elm.HelpTooltip : ''} prompt={elm.Prompt} allowBlanks={!!elm.AllowBlanks} />
    {elm.RichText ?
      <TextBox novars={true} deltas={initialValues[name]} placeholder={`${elm.Example ? `Example: ${elm.Example}` : ''}`} save={(html) => {
        elmValueChange(html)
      }} /> :
      <Form onSubmit={() => { }}
        subscription={{}}
        initialValues={initialValues}
        //render={({ values }) => (<>
        render={() => (<>
          <TextInput disabled={!allowModify} placeholder={`${elm.Example ? `Example: ${elm.Example}` : ''}`} name={name} required={!elm.AllowBlanks} variant="outlined" validationrule={elm.ValidationRule} valuechange={elmValueChange} />
          <OnChange name={name}>
            {elmValueChange}
          </OnChange>
        </>)} //debug: <pre>{JSON.stringify(values, 0, 2)}</pre>
      />}
  </div>
}

RenderTextInput.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
  valIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  valueChange: PropTypes.func.isRequired,
  allowModify: PropTypes.bool.isRequired,
}